import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/shared/api';
import { BaseApi } from '@/shared/api/baseApi';
import { ENTITY_CONFIGS } from '@/shared/constants/entities';
import type { CreateUserData, CurrentUser, User } from '@/shared/types/user';

const usersApiInstance = new BaseApi<User, CreateUserData>(ENTITY_CONFIGS.users.endpoints);

export const usersApi = {
  getList: usersApiInstance.getList.bind(usersApiInstance),
  getOne: usersApiInstance.getOne.bind(usersApiInstance),
  create: usersApiInstance.create.bind(usersApiInstance),
  update: usersApiInstance.update.bind(usersApiInstance),
  delete: usersApiInstance.delete.bind(usersApiInstance),

  getCurrentUser: async (): Promise<CurrentUser> => {
    const response = await api.get<CurrentUser>(API_ENDPOINTS.AUTH.CURRENT_USER);
    return response.data;
  },

  logout: (): Promise<void> => {
    return api.delete(API_ENDPOINTS.AUTH.LOGOUT);
  },
};
